// extracted by mini-css-extract-plugin
module.exports = {"container":"handleBarStyles_container__3sIcF","handleBar":"handleBarStyles_handleBar__c7w7j"};